/**
 * How the customer screens read an outstanding balance.
 *
 * The formatters moved down into `core-i18n` when a third feature was
 * about to copy them. This did not: "when does an encours become alarming"
 * is a decision about this product's customers, and a core package may not
 * hold a business concept.
 */

/**
 * The tone a credit bar is drawn in.
 *
 * Three bands rather than a gradient: the reader is deciding whether to act,
 * and "83%" against "84%" is not a decision. Over the limit is danger, close
 * to it is a warning, and everything else is neutral — the accent is reserved
 * for the one figure on a screen that matters.
 */
export function creditTone(usagePct: number, over: boolean): "danger" | "warning" | "neutral" {
  if (over) return "danger";
  return usagePct >= 80 ? "warning" : "neutral";
}
